var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPesquisarBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pesquisar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3B-Liner_Desktop_Home_Escuro",
    transform: "translate(-1224.000000, -685.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(645.000000, 633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(566.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.828449,42.7235296 C21.2012491,42.7235296 15.0181818,36.5214761 15.0181818,28.8708557 C15.0181818,21.2202353 21.2012491,15.0181818 28.828449,15.0181818 C36.4556489,15.0181818 42.6387162,21.2202353 42.6387162,28.8708557 C42.6387162,36.5214761 36.4556489,42.7235296 28.828449,42.7235296 Z M43.9818182,43.9818182 L39.8194729,39.8954537",
    id: "pesquisar",
    transform: "translate(29.500000, 29.500000) scale(-1, 1) translate(-29.500000, -29.500000) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisarBig);
export default __webpack_public_path__ + "static/media/pesquisar_big.e6fbbfb1a79b42f9da23095da964938f.svg";
export { ForwardRef as ReactComponent };